import React, { useState, useEffect } from 'react'
import posed from 'react-pose'
import Icon from '../../components/utils/Icon'
import Button from '../../components/utils/Button'

const Content = posed.div({
  closed: {
    opacity: 0,
    height: 0,
    marginBottom: '0rem',
  },
  open: {
    opacity: 1,
    height: 'auto',
    marginBottom: '1.25rem',
  },
})

const PosedWrapper = posed.div({
  start: { opacity: 0, y: '10px' },
  end: {
    opacity: 1,
    staggerChildren: 50,
    delayChildren: 500,
    y: '0px',
    transition: {
      duration: 800,
    },
  },
})

const PosedFooter = posed.div({
  start: { opacity: 0 },
  end: {
    opacity: 1,
    delay: 500,
    transition: {
      duration: 1000,
    },
  },
})

const Faq = ({ history, location, faqs }) => {
  const [open, setOpen] = useState(-1)
  // const { state } = location

  useEffect(
    () =>
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      }),
    []
  )

  return (
    <>
      <PosedFooter
        initialPose="start"
        pose="end"
        className="fixed bottom-0 left-0 z-auto w-full shadow-lg bg-body-lightest lg:max-w-lg h-half-screen will-change-transform"
      ></PosedFooter>
      <h2 className="mb-4 text-2xl font-semibold leading-tight text-white lg:mb-6">
        Frequently asked questions
      </h2>
      <div className="z-10 mb-4 lg:mb-6">
        <Button
          variant="tertiary"
          onClick={() => history.goBack()}
          className="border-0"
        >
          <span className="flex items-center justify-center block w-full pl-2">
            <Icon icon="back" />
            <span className="block px-2">Back to home screen</span>
          </span>
        </Button>
      </div>
      <PosedWrapper
        initialPose="start"
        pose="end"
        className="relative flex flex-col mb-4 overflow-hidden bg-white rounded-lg shadow-md"
      >
        {faqs.map((faq, index) => (
          <div
            className="border border-t-0 border-l-0 border-r-0 border-body-lighter"
            key={`faq-${index}`}
          >
            <div
              className="flex items-center justify-between px-4 cursor-pointer"
              onClick={() => setOpen(open === index ? -1 : index)}
            >
              <span className="py-4 mr-2 font-semibold text-secondary">
                <div dangerouslySetInnerHTML={{ __html: faq.question }} />
              </span>
              <span className="text-tertiary">
                <Icon
                  className="w-auto h-3"
                  icon={open === index ? 'upArrow' : 'downArrow'}
                />
              </span>
            </div>
            <Content
              className="pl-4 pr-12 overflow-hidden"
              pose={open === index ? 'open' : 'closed'}
            >
              <div
                className="c-faq"
                dangerouslySetInnerHTML={{ __html: faq.answer }}
              />
            </Content>
          </div>
        ))}
      </PosedWrapper>
      {/* <div className="z-10 px-6 pt-4 mb-6 -mx-6 bg-body-lightest">
        <span className="block mb-4 font-semibold">
          If there is an issue or query with your order
        </span>
        {state && state.name && state.mobileNumber && (
          <>
            <span data-cy="store-contact" className="block mb-2">
              If you are waiting to collect your order at the store and have an
              issue, then please call the {state.name} store team on &nbsp;
              <a
                href={`tel:${state.mobileNumber}`}
                className="inline-block text-base underline text-body"
                data-cy="store-collection-mobile"
              >
                {state.mobileNumber}
              </a>
              .
            </span>
          </>
        )}
        <>
          If there is an issue whilst collecting your order please contact the{' '}
          <a href="https://my.morrisons.com/storefinder/">store directly</a> who
          will be happy to help. For any other queries please contact our
          Customer Service Desk on{' '}
          <a
            href="tel:03456116111"
            className="inline-block text-base underline text-body"
          >
            0345 611 6111
          </a>
          .
        </>
      </div> */}
      <div className="z-10 mb-8 ">
        <Button variant="outlined" onClick={() => history.goBack()}>
          <span className="flex items-center justify-center block w-full pl-2">
            <Icon icon="back" />
            <span className="block px-2">Back to home screen</span>
          </span>
        </Button>
      </div>
      <div className="hidden c-markdown">
        <ol>
          <li>Test</li>
        </ol>
      </div>
    </>
  )
}

export default Faq
